import request from '@/utils/request';

const PATH = '/business/store/info';

export const getBusinessStoreInfo = () => request({
  url: PATH,
  method: 'get',
});

export const updateBusinessStoreInfo = (data: any) => request({
  url: PATH,
  method: 'put',
  data,
});
